import { useState } from 'react';
import { LocalizedService, useLocalizedServiceFactory } from '../../API/GoMoto';
import { getRndServiceDisplayName } from '../../helpers/rndServiceDisplayName';
import { useBackgroundDataState } from '../../context/backgroundData';
import { Types, useCart, useCartDispatch } from '../../context/cart';
import { useLocalization } from '../../context/Localization/localization';
import { ServiceCard } from '../ServiceCard/ServiceCard';
import { SpgPriceText } from '../SpgPriceText/SpgPriceText';
import { ServiceCardListItemProps } from './ServiceCardListItem.types';

/**
 * @param rndService - {@link ServiceCardListItemProps.rndService rndService} description.
 * @param index - {@link ServiceCardListItemPropss.index index} description.
 */
export const ServiceCardListItem = ({
    rndService,
    index,
}: ServiceCardListItemProps) => {
    const Localization = useLocalization();
    const { standardServices } = useBackgroundDataState();
    const serviceFactory = useLocalizedServiceFactory();
    const cartDispatch = useCartDispatch();
    const cart = useCart();
    const [doneElsewhere, setDoneElsewhere] = useState<boolean>(
        cart.rndServices.findIndex((cartService) =>
            rndService.opCode === cartService.opCode && cartService.doneElsewhere,
        ) > -1,
    );
    const localizedService: LocalizedService | undefined = rndService.linkedService ? serviceFactory(rndService.linkedService) : undefined;
    const pricedSPGService = standardServices.find((s) => rndService.opCode === s.opCode);

    return (
        <ServiceCard
            key={`rndservice-${rndService.opCode}-${index}`}
            onClick={() => {
                cartDispatch({
                    type: Types.ToggleRNDService,
                    payload: {
                        ...rndService,
                        doneElsewhere: false,
                    },
                });

                setDoneElsewhere(false);
            }}
            priceDetails={localizedService ? localizedService.localization.priceDetails : undefined}
            name={getRndServiceDisplayName(rndService, localizedService)}
            description={localizedService ? localizedService.localization.description : undefined}
            checked={cart.rndServices.findIndex((cartService) => rndService.opCode === cartService.opCode && !cartService.doneElsewhere) > -1}
            price={
                <>
                    <SpgPriceText
                        price={rndService.price ?? localizedService?.price}
                        priceLow={localizedService?.priceLow}
                        priceHigh={localizedService?.priceHigh}
                        spgPricing={localizedService?.useSpgPricing ? localizedService?.spgPricing : undefined}
                    />
                    {!!rndService.price &&
                        rndService.price <
                        (pricedSPGService?.priceLow ?? pricedSPGService?.priceHigh ?? pricedSPGService?.price ?? 0)
                        && (
                            <SpgPriceText
                                price={pricedSPGService?.price}
                                priceLow={pricedSPGService?.priceLow}
                                priceHigh={pricedSPGService?.priceHigh}
                                spgPricing={pricedSPGService?.useSpgPricing ? pricedSPGService?.spgPricing : undefined}
                                markOut={true}
                            />
                        )
                    }
                </>
            }
            extraOption={{
                checked: doneElsewhere,
                label: Localization.IHadThisServiceDoneElsewhere,
                onClick: () => {
                    if (doneElsewhere) {
                        cartDispatch({
                            type: Types.RemoveRNDService,
                            payload: {
                                ...rndService,
                                opCode: rndService.opCode,
                            },
                        });
                    }
                    else {
                        cartDispatch({
                            type: Types.ToggleRNDService,
                            payload: {
                                ...rndService,
                                doneElsewhere: !doneElsewhere,
                            },
                        });
                    }

                    setDoneElsewhere(!doneElsewhere);
                },
            }}
        />

    );
};